import type { ReactElement } from 'react';

import { MasterDetail, useDetailRoute } from '@/ui/kit';

import { AccountDetailScreen } from './AccountDetailScreen';
import { AccountsListScreen } from './AccountsListScreen';
import { ACCOUNTS_USERS_PATH } from './routes';

/**
 * Comptes : la liste et, a cote, la fiche du compte ouvert (maquette P05).
 *
 * Ouvrir une fiche ne fait pas perdre la liste : sa recherche, sa page, sa
 * position restent. La selection vit dans l'URL (`/accounts/users/<id>`), qui
 * reste donc valide en lien direct. La liste elle-meme n'a pas change : ses
 * lignes sont des liens vers ce meme chemin.
 *
 * La fiche est montee **avec l'identifiant pour cle** : passer d'un compte a un
 * autre repart d'un etat neuf. Sans cela, la derniere fiche conservee apres un
 * echec de lecture (comportement voulu) serait celle du compte precedent.
 */
export const AccountsScreen = (): ReactElement => {
  const detail = useDetailRoute(ACCOUNTS_USERS_PATH);

  return (
    <MasterDetail
      list={<AccountsListScreen />}
      selectedId={detail.selectedId}
      detailLabel="Fiche du compte"
      onClose={detail.close}
      renderDetail={(id) => <AccountDetailScreen key={id} userId={id} />}
    />
  );
};
